import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Injector } from '@angular/core';
import { COMMON_CONSTANTS, ITEMS_PRIORITY, LINE_IDENTIFIER, MANAGE_LINE_CONST } from '../../../common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ChangeServiceService } from 'src/app/services/change-service.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { ConflictingModalComponent } from '../../../shared/components/conflicting-modal/conflicting-modal.component';
import { ConfirmOrCancelModalComponent } from "src/app/shared/components/confirm-or-cancel-modal/confirm-or-cancel-modal.component";
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EvaluatePromotionComponent } from '../../../shared/components/evaluate-promotion/evaluate-promotion.component';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { ScamInfoComponent } from '../scam-info/scam-info.component';
import {PnpClientService} from '../../../../pnpframework/lib/services/pnp-client.service';
import { SearchPipePipe } from 'src/app/shared/pipes/search-pipe.pipe';
import { ServiceFilterPipe } from '../../pipes/service-filter.pipe';
@Component({
  selector: 'app-changeservice',
  templateUrl: './changeservice.component.html',
  styleUrls: ['./changeservice.component.scss'],
  providers: [ServiceFilterPipe,SearchPipePipe]
})

export class ChangeserviceComponent implements OnInit, OnDestroy {
  public selectedServiceIndex: number;
  public conflictedService: string;
  public modalReference: any;
  public authoringContentData: any;
  public servicesList = [];
  public servicesListCurrentState = [];
  public showSearch = false;
  public allTypes = [];
  public searchText = '';
  public allServices = [];
  public subscribersData: any;
  public types = [];
  public isEdited = false;
  public previousServicesTotal = 0;
  public currentServicesTotal = 0;
  public groupType = COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALL_TYPES;
  public serviceType = COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALL_SERVICES;
  public itemsPriority = ITEMS_PRIORITY;
  public subscriberData: any;
  public screenName: string;
  public currentServArray = [];
  public addedServArray = [];
  public removedServArray = [];
  public serviceSelectionChangedSubs: Subscription;
  public triggerPromoApiSubs: Subscription;
  public two = COMMON_CONSTANTS.DIGITS.TWO;
  public zero = COMMON_CONSTANTS.DIGITS.ZERO;
  public k2k_socs = COMMON_CONSTANTS.SERVICES.K2K_SOCS;
  currentSelectedServices: any[];
  private isk2kEnabled = environment.ENABLE_K2K_SOCS_FLOW;
  currentGrandfatherSoc:any;
  public enableMultiPromo: boolean = false;
  public evaluateApiTriggered:boolean;
  removingCurrentSrv: any;
  addingServToGetConflictModal: any;
  serviceInfo = { Data: {}, Blocking: {}, Other: {} };
  @ViewChild('promoError') promoError: ElementRef;
  lineDetails: any;
  public descArrray:any = [];
  servicesListForRender: any[];
  servicesFetched = false;
  isEndUser: boolean;
  isOktaUser: boolean;
  ngbModalOptions: NgbModalOptions;
  isRunningInGlobalNav: boolean;
  _utilsSvc: UtilsService;
  modalService: NgbModal;
  _cacheSvc: HttpCacheService;
  _changeSvc: ChangeServiceService;
  router: Router;
  serviceFilter: ServiceFilterPipe;
  searchFilter: SearchPipePipe;
  _loaderSvc: LoaderService;
  manageLineService: ManageLineService;
  _helperUtilSvc: HelperUtilityService;
  pdlService: PDLService;
  _pnpClientService: PnpClientService;

  constructor(
   private injector : Injector) {
    this._utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this._changeSvc = this.injector.get<ChangeServiceService>(ChangeServiceService);
    this.router = this.injector.get<Router>(Router);
    this.serviceFilter = this.injector.get<ServiceFilterPipe>(ServiceFilterPipe);
    this.searchFilter = this.injector.get<SearchPipePipe>(SearchPipePipe);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.pdlService = this.injector.get<PDLService>(PDLService);
    this._pnpClientService = this.injector.get<PnpClientService>(PnpClientService);
      this.currentGrandfatherSoc = false;
  }

  ngOnInit() {
    this.enableMultiPromo = environment.ENABLE_EVALUATE_PROMOTION;
    sessionStorage.removeItem(COMMON_CONSTANTS.SERVICES.DESC_DETAILS);
    this.isOktaUser = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY ? true : false;
    this.evaluateApiTriggered = false;
    sessionStorage.removeItem('currentServicesOnLoad');
    sessionStorage.removeItem('addedServices');
    sessionStorage.removeItem('removedServices');
    this.isEndUser = this._helperUtilSvc.isEndUser();
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    this.initialAssignments();
    this.getSubscriberDetails();
    this.serviceSelectionChangedSubs = this._changeSvc.serviceSelectionChanged.subscribe((data) => {
      if (!isNullOrUndefined(data) && data === true) {
        this.storeConflictingServices();
        this.changeCurrentservicesTotal();
        this.stickyFooterUpdate();
        this.setAddedOrRemovedServices();
      }
    });
    this.triggerPromoApiSubs = this._changeSvc.triggerPromoApi.subscribe((data) => {
      if (!isNullOrUndefined(data) && data === true) {
        let remainingCurrentSocs=_.clone(this.currentServArray);
        if(!isNullOrUndefined(this.removingCurrentSrv)){
          remainingCurrentSocs.splice(remainingCurrentSocs.indexOf(this.removingCurrentSrv.soc), COMMON_CONSTANTS.DIGITS.ONE);
        }
        if(remainingCurrentSocs.length <= 0){
          let subscriberData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_DATA));
          remainingCurrentSocs.push(subscriberData.subscriber.subscriberInfo.pricePlanCode);
        }
        this.triggerEvaluatePromotion(remainingCurrentSocs,this.removingCurrentSrv);
      }
    });

    this.screenName = window.sessionStorage.getItem('screenName');
    this.pdlService.ifEnabledGeneratePageViewTag(this.router.url);
    this.isRunningInGlobalNav = this._pnpClientService.isRunningInGlobalNav();
  }


  initialAssignments() {
    this.authoringContentData = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.CONTENT));
    this.types = [COMMON_CONSTANTS.ALL_TYPES_SERVICE.DATA, COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING,
    COMMON_CONSTANTS.ALL_TYPES_SERVICE.OTHER];
    this.allTypes = [COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALL_TYPES, COMMON_CONSTANTS.ALL_TYPES_SERVICE.DATA,
    COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING, COMMON_CONSTANTS.ALL_TYPES_SERVICE.OTHER];
    this.allServices = [COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALL_SERVICES, COMMON_CONSTANTS.ALL_TYPES_SERVICE.CURRENT_SERVICES,
    COMMON_CONSTANTS.ALL_TYPES_SERVICE.AVAILABLE_SERVICES];
    this.subscriberData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_DATA));
    this.lineDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.LINE_DETAILS));
  }

  getSubscriberDetails() {
    this._loaderSvc.start();
    this._changeSvc.getSubscriberDetails().subscribe((response) => {
      this.subscribersData = response;
      this._cacheSvc.putInSessionStoarage(COMMON_CONSTANTS.SUBSCRIBER_DATA, JSON.stringify(this.subscribersData));
      this.getChangeServiceDetails();
    }, (error) => {
      this._loaderSvc.stop();
      this._utilsSvc.errorHandling(error);
    });
  }

  getChangeServiceDetails() {
      this._changeSvc.getChangeServiceDetails().subscribe((response) => {
      //ML PTT Filter
      if(environment.ENABLE_ML_PTT_FEATURE){
        this.manageLineService.filter_ML_PTT(response);
      }
      if(environment.ENABLE_IDP){
        this.manageLineService.filter_IDP_SOC(response);
      }
      this.servicesFetched = true;
      this.segregateServicesData(response);
      this.splitAndSort(this.itemsPriority);
      this.storeConflictingServices();
      this.servicesListForRender = this.servicesList
      this.sortSatelliteSocs();
      this.setDataForViewMoreLinks(true);
      this.currentServicesTotal = this.previousServicesTotal;
      this._loaderSvc.stop();
      sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.INITIAL_SERVICES_LIST, JSON.stringify(this.servicesList));
      sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.SERVICES_LIST_CURRENT_STATE, JSON.stringify(this.servicesList));
    }, (error) => {
      this._loaderSvc.stop();
      this._utilsSvc.errorHandling(error);
    });
  }

  updateData(type) {
    const list = this.serviceFilter.transform(this.servicesList, type);
    const maxLength = !isNullOrUndefined(list) ? list.length : COMMON_CONSTANTS.DIGITS.ZERO;
    if (!isNullOrUndefined(this.serviceInfo[type] && type)) {
      this.serviceInfo[type].isExpanded = true;
      this.serviceInfo[type].showCount = maxLength
      this.serviceInfo[type].isCollapsingFreezed = true;
    }
  }

  setDataForViewMoreLinks(isInitial?) {
    let typeKeys = Object.keys(this.serviceInfo);
    for (let key of typeKeys) {
      const filteredListOfType = this.serviceFilter.transform(this.servicesListForRender, key);
      if(isInitial){
        this.serviceInfo[key] = {
          showCount: COMMON_CONSTANTS.DIGITS.TWO,
          maxCount: !isNullOrUndefined(filteredListOfType) ? filteredListOfType.length : COMMON_CONSTANTS.DIGITS.ZERO,
          isExpanded: false,
          isCollapsingFreezed: false,
        };
      } else {
        this.serviceInfo[key].maxCount = !isNullOrUndefined(filteredListOfType) ? filteredListOfType.length : COMMON_CONSTANTS.DIGITS.ZERO;
      }

    }
  }


  getServicesLength(data,isSearchFilter) {
    let filteredListOfType;
    if(isSearchFilter){
      filteredListOfType = this.searchFilter.transform(this.servicesListForRender, data);
    }else {
      filteredListOfType = this.serviceFilter.transform(this.servicesListForRender, data);
    }
    if(!isNullOrUndefined(filteredListOfType)){
      return filteredListOfType.length;
    }
  }

  getCurrentConflictingServices(selectedService) {
    if (!isNullOrUndefined(selectedService)) {
      const conflictingSocs = <any[]>selectedService.currentlyConflictingWith;
      _.each(this.servicesList, (item) => {
        _.each(conflictingSocs, (soc) => {
          if (item.soc === soc && item.currentService === true) {
            this.removingCurrentSrv = item;
          }
        });
      });
    }
  }

  checkBoxClicked(service: any) {
    if (!isNullOrUndefined(service)) {
      const scamSocs = COMMON_CONSTANTS.SERVICES.SCAM_SOCS;
      const enableSuziPopup = environment.ENABLE_SUZI_SHEEP;
      if (enableSuziPopup  && this.isOktaUser && !isNullOrUndefined(scamSocs) && scamSocs.indexOf(service.soc) > COMMON_CONSTANTS.DIGITS.MINUS_ONE && service.isSelected && !service.currentService) {
        const scamInfoRef = this.modalService.open(ScamInfoComponent, this.ngbModalOptions);
        scamInfoRef.componentInstance.isProceedClicked.subscribe((data) => {
          if (!isNullOrUndefined(data) && data) {
            this.checkChange(service);
          } else {
            service.isSelected = false;
          }
        });

      } else {
        this.checkChange(service);
      }
    }
  }

    
  checkConflictingPromotionRedemptionFlows(service): boolean {
    if (service.isNFLX && service.isSelected) { // If NFLX SOC
      // Check if any current selected services has HULU as true
      const hasHULUTrue = this.currentSelectedServices.some(item => item.isHULU === true);
      if (hasHULUTrue) return false; // Condition failed
    }

    if (service.isHULU && service.isSelected) { // If HULU SOC
      // Check if any current selected services has NFLX as true
      const hasNFLXTrue = this.currentSelectedServices.some(item => item.isNFLX === true);
      if (hasNFLXTrue) return false; // Condition failed
    }

    return true; // All conditions have passed
  }

  checkChange(service: any) {
    this.currentGrandfatherSoc = false;
    if (service.currentlyConflictingWith.length > COMMON_CONSTANTS.DIGITS.ZERO && service.isSelected === true) {
      this.addingServToGetConflictModal = service;
      this.getCurrentConflictingServices(service);
      /**Conflict modal scenario */
      const conflictingModalRef = this.modalService.open(ConflictingModalComponent, this.ngbModalOptions);
      conflictingModalRef.componentInstance.servicesList = this.servicesList;
      conflictingModalRef.componentInstance.currentSelectedServices = this.currentSelectedServices;
      conflictingModalRef.componentInstance.selectedService = service;
      conflictingModalRef.componentInstance.currentServArray = this.currentServArray;
      if (service.isNFLX || service.isk2k || service.isHULU) {
        conflictingModalRef.componentInstance.k2kPopUp = true;
        conflictingModalRef.componentInstance.k2kAddPopUp = true;
      } else {
        conflictingModalRef.componentInstance.conflictPopup = true;
      }
    } else if(!this.checkConflictingPromotionRedemptionFlows(service)) {
      const conflictingModalRef = this.modalService.open(ConflictingModalComponent, this.ngbModalOptions);
      conflictingModalRef.componentInstance.servicesList = this.servicesList;
      conflictingModalRef.componentInstance.currentSelectedServices = this.currentSelectedServices;
      conflictingModalRef.componentInstance.selectedService = service;
      conflictingModalRef.componentInstance.conflictingRedemptionSocPopup = true;
    } else if(service.grandfatheredFlag === true && !service.isSelected){
      this.removingCurrentSrv = service;
        const conflictingModalRef = this.modalService.open(ConflictingModalComponent, this.ngbModalOptions);
        conflictingModalRef.componentInstance.servicesList = this.servicesList;
        conflictingModalRef.componentInstance.currentSelectedServices = this.currentSelectedServices;
        conflictingModalRef.componentInstance.selectedService = service;
        conflictingModalRef.componentInstance.grandFatherPopup = true;
    }else {
      let grandFatherK2k;
      _.each(this.servicesList, (selectedService) => {
        if (selectedService.grandfatheredFlag === true && (selectedService.isk2k || selectedService.isNFLX || service.isHULU) && selectedService.currentService) {
          this.currentGrandfatherSoc = true;
          grandFatherK2k = selectedService;
        }
      });
      if (service.isSelected && !isNullOrUndefined(grandFatherK2k) && grandFatherK2k.conflictingServices.length == COMMON_CONSTANTS.DIGITS.ZERO && (service.isk2k || service.isNFLX || service.isHULU) && this.currentGrandfatherSoc){
            const conflictingModalRef = this.modalService.open(ConflictingModalComponent, this.ngbModalOptions);
            conflictingModalRef.componentInstance.servicesList = this.servicesList;
            conflictingModalRef.componentInstance.currentSelectedServices = this.currentSelectedServices;
            conflictingModalRef.componentInstance.selectedService = service;
            conflictingModalRef.componentInstance.k2kPopUp = true;
            conflictingModalRef.componentInstance.restrictedInReviewTyp = COMMON_CONSTANTS.SERVICES.ADDITION;
          }

      this.evaluateApiTriggered = false;

      const itemIndex = this.getIndexOfSocV2(this.currentSelectedServices, service.soc);

      /** Removing soc scenario */
      if (!service.isSelected && itemIndex >= 0) {
        if(_.includes(this.currentServArray,service.soc) && this.enableMultiPromo && !service.isk2k && (!service.isNFLX || !service.isHULU) && service.grandfatheredFlag === false){
          // api call should be triggered for k2k soc and grandfathered soc removal should be handled in grandfathered modal
          let remainingCurrentSocs=_.clone(this.currentServArray);
          remainingCurrentSocs.splice(remainingCurrentSocs.indexOf(service.soc), 1);
          /**remainingCurrentSocs contains all the current socs expect the one which is removing*/
          if(remainingCurrentSocs.length <= 0){
            let subscriberData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_DATA));
            remainingCurrentSocs.push(subscriberData.subscriber.subscriberInfo.pricePlanCode);
          }
           /* call evaluate promo api */
          this.triggerEvaluatePromotion(remainingCurrentSocs,service);
        }else{
          this.currentSelectedServices.splice(itemIndex, 1);
        }
      }

      const temp = _.cloneDeep(service);
      /** Adding soc without conflict scenario */
      if (service.isSelected && itemIndex < 0) {
   	         if(service.price>0){
               	  const modalRef = this.modalService.open(ConfirmOrCancelModalComponent, this.ngbModalOptions);
                   modalRef.componentInstance.title = this.authoringContentData.changeService.currentDatePopupTitle;
                   modalRef.componentInstance.body = this.authoringContentData.changeService.currentDatePopupText;
                   modalRef.componentInstance.cancelBtnTxt = this.authoringContentData.changeService.cancelTxt;
                   modalRef.componentInstance.confirmBtnTxt = this.authoringContentData.changeService.currentDateAddCTA;
                   modalRef.componentInstance.dismissAllOnClose = true;
                   modalRef.componentInstance.confirmBtnClicked.subscribe((confirmed) => {
                     if (confirmed) {
                       temp.effectiveToday = true;
                       service.effectiveToday = true;
                       this.currentSelectedServices.push(temp);
                     }else {
                       service.isSelected = false;
                     }
                    this.isEvaluateApiTriggered();
                   })
              } else {
                  temp.effectiveToday = true;
                  service.effectiveToday = true;
                  this.currentSelectedServices.push(temp);
              }
      }

      this.isEvaluateApiTriggered();

    }
    sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.SERVICES_LIST_CURRENT_STATE, JSON.stringify(this.servicesListCurrentState));
  }

  isEvaluateApiTriggered(){
    if(!this.evaluateApiTriggered){
      this.storeConflictingServices();
      this.changeCurrentservicesTotal();
      this.stickyFooterUpdate();
      this.setAddedOrRemovedServices();
    }
  }
  triggerEvaluatePromotion(remainingCurrentSocs,removingServ){
    this.evaluateApiTriggered = true;
    this._loaderSvc.start();
    let reqbody:any = {};
    let accountDetailObj:any = {};
    let linesArray:any = [];
    let linesArrayObj:any = {};

    linesArrayObj.mobileNumber = !isNullOrUndefined(this.subscribersData) ? this.subscribersData.msisdn: '';
    linesArrayObj.lineType = !isNullOrUndefined(this.subscribersData && this.subscribersData.subscriber) ? this.subscribersData.subscriber.productType: '';
    linesArrayObj.lineStatus = COMMON_CONSTANTS.SERVICES.ACTIVE_STATUS_CODE;
    linesArrayObj.socs = remainingCurrentSocs;
    linesArray.push(linesArrayObj);

    accountDetailObj.billingAccount = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY) ? this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.BAN_NUMBER_KEY) : '';
    accountDetailObj.lines = linesArray;
    reqbody.accountDetail = accountDetailObj;
    this._changeSvc.evaluatePromotion(reqbody).subscribe(response => {
      this._loaderSvc.stop();
      let promoArray:any = [];
      if(!_.isUndefined(response.lostPromotions) && response.lostPromotions.length > 0){
        _.each(response.lostPromotions, (promo) => {
          promoArray.push(promo.description);
        });
        if(promoArray.length > 0){
          this.ngbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            centered: false,
            container: '#am-container-custom',
          };
          _.each(response.lostPromotions, (promo) => {
            let descArrrayObj:any = {};
            descArrrayObj.soc = removingServ.soc;
            descArrrayObj.description = promo.description;
            this.descArrray.push(descArrrayObj);
          });

          /**Removing duplicates */
          this.descArrray = this.descArrray.reduce(function(all, current){
            if (checkIfAlreadyExist(current)) {
              return all;
            } else {
              return all.concat(current);
            }
            function checkIfAlreadyExist(currentVal) {
              return all.some(function(item) {
                return (item.soc === currentVal.soc &&
                        item.description === currentVal.description);
              });
            }
          }, []);
          sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.DESC_DETAILS, JSON.stringify(this.descArrray));

          let billingAccountResponse = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.TEA_RESPONSE)) ? JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.TEA_RESPONSE)) : {};
          let subscriberLineDetailsResponse = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_LINE_DETAILS)) ? JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_LINE_DETAILS)) : {};
          let primaryUdfDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(LINE_IDENTIFIER.PRIMARY_UDF));
          let primaryUdfLabel = !isNullOrUndefined(primaryUdfDetails) ? primaryUdfDetails.configValue.toLowerCase().replace('id','') : '';
          let primaryUDFValue = '--';
          if(!isNullOrUndefined(billingAccountResponse)){
            _.each(billingAccountResponse.subscribers,(obj)=>{
              if(obj.msisdn === this.subscribersData.msisdn){
                primaryUDFValue = !_.isUndefined(obj.lineIdentifier[primaryUdfLabel]) ? obj.lineIdentifier[primaryUdfLabel] : '--';
              }
            });
          }else if(!isNullOrUndefined(subscriberLineDetailsResponse)){
            if(subscriberLineDetailsResponse.msisdn === this.subscribersData.msisdn){
              primaryUDFValue = !_.isUndefined(subscriberLineDetailsResponse.lineIdentifier[primaryUdfLabel]) ? subscriberLineDetailsResponse.lineIdentifier[primaryUdfLabel] : '--';
            }
          }

          let price = (typeof removingServ.price !== 'undefined') ? ' ($' + Number(removingServ.price).toFixed(2) + ')': ' ';
          const conflictingModalRef = this.modalService.open(EvaluatePromotionComponent, this.ngbModalOptions);
          conflictingModalRef.componentInstance.removingService = removingServ.name+price;
          conflictingModalRef.componentInstance.promotionDesc = promoArray;
          conflictingModalRef.componentInstance.lineID = primaryUDFValue;
          conflictingModalRef.componentInstance.isPromo = true;
          conflictingModalRef.componentInstance.currentServArray = this.currentServArray;
          conflictingModalRef.componentInstance.servicesList = this.servicesList;
          conflictingModalRef.componentInstance.currentSelectedServices = this.currentSelectedServices;
          conflictingModalRef.componentInstance.addingServToGetConflictModal = this.addingServToGetConflictModal;
          conflictingModalRef.componentInstance.selectedService = removingServ;
      }else{
        this.handlePromoApiInvalidCondition(removingServ);
        }
      }else{
        this.handlePromoApiInvalidCondition(removingServ);
      }
    }, (error) => {
      this._loaderSvc.stop();
      this.modalService.open(this.promoError);
    });
  }
  handlePromoApiInvalidCondition(removingServ){
    if (!isNullOrUndefined(removingServ)) {
      removingServ.isSelected = false;
      const index = this.getIndexOfSocV2(this.currentSelectedServices, removingServ.soc);
      if (index !== -1) {
        this.currentSelectedServices.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
      }
    }
    this.storeConflictingServices();
    this.changeCurrentservicesTotal();
    this.stickyFooterUpdate();
    this.setAddedOrRemovedServices();
  }
  setAddedOrRemovedServices() {
    this.addedServArray = [];
    this.removedServArray = [];
    _.each(this.servicesList, (service) => {
      if (service.currentService && (!service.isSelected)) {
        service.status = COMMON_CONSTANTS.SERVICE_STATUS.REMOVED;
        this.removedServArray.push(service);
      }
      if ((!service.currentService) && service.isSelected) {
        service.status = COMMON_CONSTANTS.SERVICE_STATUS.ADDED;
        this.addedServArray.push(service);
      }
    });
    sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.ADDED_SERVICES, JSON.stringify(this.addedServArray));
    sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.REMOVED_SERVICES, JSON.stringify(this.removedServArray));
  }

  getIndexOfSocV2(array: any[], item) {
    let index = -1;
    _.each(array, (service, ind) => {
      if (service.soc === item) {
        index = ind;
      }
    });
    return index;
  }

  getNameOfSoc(soc) {
    const index = this.getIndexOfSocV2(this.servicesList, soc);
    return this.servicesList[index].name ? this.servicesList[index].name : this.servicesList[index].description;
  }

  stickyFooterUpdate() {
    let tempVar = true;
    tempVar = _.every(this.servicesList, (service) => {
      if (service.currentService) {
        return service.isSelected;
      } else {
        return !service.isSelected;
      }
    });
    this.isEdited = tempVar ? false : true;
  }


  showSearchOption() {
    this.showSearch = true;
    const typeKeys = Object.keys(this.serviceInfo);
    for(let type of typeKeys) {
    const list = this.serviceFilter.transform(this.servicesList, type);
    const maxLength = !isNullOrUndefined(list) ? list.length : COMMON_CONSTANTS.DIGITS.ZERO;
      if(!isNullOrUndefined(this.serviceInfo[type])){
        this.serviceInfo[type].isExpanded = true;
        this.serviceInfo[type].showCount = maxLength;
      }
    }
  }

  segregateServicesData(data) {

    this.setFlagForK2kServices(data);
    _.each(_.get(data.currentServices, COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALLSERVICES, ''), (pkg) => {
        pkg[COMMON_CONSTANTS.SERVICES.CURRENT_SERVICE] = true;
        pkg.isSelected = true;
        if (pkg.level === undefined) {
          pkg[COMMON_CONSTANTS.PACKAGE.LEVEL] = COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER;
        }
        pkg.status = COMMON_CONSTANTS.SERVICE_STATUS.ADDED;
        this.servicesList.push(pkg);
        this.currentServArray.push(pkg.soc);
    });
     sessionStorage.setItem('currentServicesOnLoad', JSON.stringify(this.servicesList));
    const eligibleIncompatibleServices = _.isEmpty(data.eligibleServices) ? [] :
      _.map(data.eligibleServices.incompatibleSocs, (item) => item.value);

    if(this._utilsSvc.isNotNullOrUndefined(data?.eligibleServices)){
      data.eligibleServices.allServices = this.filterEligibleServices(eligibleIncompatibleServices, data.eligibleServices.allServices);
    }
    _.each(_.get(data.eligibleServices, COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALLSERVICES, ''), (pkg) => {
      pkg[COMMON_CONSTANTS.SERVICES.CURRENT_SERVICE] = false;
      pkg.isSelected = false;
      if (pkg.level === undefined) {
        pkg[COMMON_CONSTANTS.PACKAGE.LEVEL] = COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER;
      }
      this.servicesList.push(pkg);
    });

    this.updateServiceList();
    sessionStorage.setItem(COMMON_CONSTANTS.SERVICES.PREVIOUS_SERVICES_TOTAL, JSON.stringify(this.previousServicesTotal));
    this.currentSelectedServices = _.cloneDeep(_.filter(this.servicesList, (item)=> item.isSelected));
    this.setConflictingSvcForCurrentServices();

  }

  updateServiceList() {
    if (!this.isk2kEnabled) {
      this.servicesList = _.filter(this.servicesList, (service) => (!service.isk2k && (!service.isNFLX || !service.isHULU)));
    }
    if (environment.ENABLE_SUZI_SHEEP && !this.isOktaUser) {
      this.servicesList = _.filter(this.servicesList, (service) => COMMON_CONSTANTS.SERVICES.SCAM_SOCS.indexOf(service.soc) === COMMON_CONSTANTS.DIGITS.MINUS_ONE);
    }
    _.each(this.servicesList, (service) => {
      if (service.currentService) {
        this.previousServicesTotal = service.price ? Number(this.previousServicesTotal)
          + Number(service.price) : Number(this.previousServicesTotal);
      }
    });
  }

  setFlagForK2kServices(data) {
    if (!isNullOrUndefined(data)) {
      this.updateServices(data.currentServices);
      this.updateServices(data.eligibleServices);
    }
  }

  updateServices(service : any){
    _.each(_.get(service, COMMON_CONSTANTS.ALL_TYPES_SERVICE.ALLSERVICES, ''), (pkg) => {
      pkg.isk2k = false;
      _.each(COMMON_CONSTANTS.SERVICES.K2K_SOCS, (k2kSoc) => {
        if (pkg.soc === k2kSoc) {
          pkg.isk2k = true;
        }
      });
      //Set flag isNFLX for all current services coming with NFX soc indicator
      pkg.isNFLX = false;
      if (pkg.socIndicator === COMMON_CONSTANTS.NETFLIX_SOC_INDICATOR){
        pkg.isNFLX = true;
      }
      //Set flag isHULU for all current services coming with HUL soc indicator
      pkg.isHULU = false;
      if (pkg.socIndicator === COMMON_CONSTANTS.HULU_SOC_INDICATOR){
        pkg.isHULU = true;
      }
    });
  }
  // creating conflictingServices object for current services
  private setConflictingSvcForCurrentServices() {
    const currentSvc = <any[]> _.filter(this.servicesList, (service) => service.currentService);
    _.each(currentSvc, (item, index) => {
      const conflictingServices = [];
      _.each(this.servicesList, (service) => {
        const isMatch = _.find(service.conflictingServices, (conf) => item.soc === conf);
        if (isMatch) {
          conflictingServices.push(service.soc);
        }
      });
      currentSvc[index].conflictingServices = conflictingServices;
    });
  }

  private filterEligibleServices(incompatibleSocs, eligibleServices) {
    if (!_.isEmpty(incompatibleSocs)) {
      eligibleServices = _.filter(eligibleServices, function (service) {
        return (incompatibleSocs.indexOf(service.soc) === -1);
      });
    }
    eligibleServices = _.filter(eligibleServices, (service) => {
      return (((service[COMMON_CONSTANTS.PACKAGE.LEVEL] === COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER ||(service[COMMON_CONSTANTS.PACKAGE.LEVEL] === COMMON_CONSTANTS.SERVICE_LEVEL.PRODUCT && service.isk2k) ||(service[COMMON_CONSTANTS.PACKAGE.LEVEL] === COMMON_CONSTANTS.SERVICE_LEVEL.PRODUCT && (service.isNFLX || service.isHULU)))&& service.subGroup !== COMMON_CONSTANTS.PACKAGE.PROTECTION_PLAN) ||
      (!(this._utilsSvc.isNotNullOrUndefined(service[COMMON_CONSTANTS.PACKAGE.LEVEL])) && !(this._utilsSvc.isNotNullOrUndefined(service[COMMON_CONSTANTS.PACKAGE.CATEGORY])) && this._utilsSvc.isNotNullOrUndefined(service[COMMON_CONSTANTS.PACKAGE.GROUP]) && service.subGroup !== COMMON_CONSTANTS.PACKAGE.PROTECTION_PLAN ) ||
      (!(this._utilsSvc.isNotNullOrUndefined(service[COMMON_CONSTANTS.PACKAGE.LEVEL])) && (this._utilsSvc.isNotNullOrUndefined(service[COMMON_CONSTANTS.PACKAGE.CATEGORY])) && !(this._utilsSvc.isNotNullOrUndefined(service[COMMON_CONSTANTS.PACKAGE.GROUP])) && service.subGroup !== COMMON_CONSTANTS.PACKAGE.PROTECTION_PLAN ));
    });
    return eligibleServices;
  }


  public splitAndSort(items_priority: any) {
    this.servicesList.sort(function (a, b) {
      return items_priority[b.group] - items_priority[a.group];
    });
  }

  isDisabled(service) {
    return service && service.currentService && (service.level === COMMON_CONSTANTS.SERVICE_LEVEL.ACCOUNT ||
      (service.level === COMMON_CONSTANTS.SERVICE_LEVEL.PRODUCT && !service.isk2k && !service.isNFLX));
  }


  filterServices() {
    if (!isNullOrUndefined(this.serviceType && this.servicesList)) {
      this.servicesListForRender = [];
      this.servicesListForRender = _.filter(this.servicesList, (item) => {
       this.checkForServices(item);
      });
    }
    if (!isNullOrUndefined(this.groupType && this.servicesListForRender)) {
      this.servicesListForRender = _.filter(this.servicesListForRender, (item) => {
       this.checkForGroupType(item);
      });
    }
    console.log(this.servicesListForRender)
    this.sortSatelliteSocs();
    this.setDataForViewMoreLinks(false);

  }

  sortSatelliteSocs() {
    this.servicesListForRender = this.servicesListForRender.sort((a, b) => {
      const getCount = (item: any): number => {
        if (item.currentService && String(item.isSatMessagingCapable).toUpperCase() === MANAGE_LINE_CONST.YES_CHECK) return 0;
        if (item.currentService) return 1;
        if (!item.currentService && String(item.isSatMessagingCapable).toUpperCase() === MANAGE_LINE_CONST.YES_CHECK) return 2;
        return 3;
      };
    
      return getCount(a) - getCount(b);
    });
  }

  checkForServices(item){
    if (this.serviceType === COMMON_CONSTANTS.ALL_TYPES_SERVICE.CURRENT_SERVICES) {
      return item && item.currentService;
    } else if (this.serviceType === COMMON_CONSTANTS.ALL_TYPES_SERVICE.AVAILABLE_SERVICES) {
      return item && !item.currentService;
    } else {
      return item;
    }
  }

  checkForGroupType(item){
    if (this.groupType === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING) {
      return !isNullOrUndefined(item) && (item.category === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK ||
        item.group === COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLOCKING_CAPS);
    } else if (this.groupType === COMMON_CONSTANTS.ALL_TYPES_SERVICE.DATA || this.groupType === COMMON_CONSTANTS.ALL_TYPES_SERVICE.OTHER) {
      return !isNullOrUndefined(item.group && this.groupType) && (item.category !== COMMON_CONSTANTS.ALL_TYPES_SERVICE.BLK) && (item.group.toLowerCase() === this.groupType.toLowerCase());
    } else {
      return item;
    }
  }

  hideSearch() {
    this.showSearch = false;
    this.searchText = '';
    const typeKeys = Object.keys(this.serviceInfo);
    for(let type of typeKeys) {
      if(!isNullOrUndefined(this.serviceInfo[type]) && !this.serviceInfo[type].isCollapsingFreezed){
        this.serviceInfo[type].isExpanded = false;
        this.serviceInfo[type].showCount = COMMON_CONSTANTS.DIGITS.TWO
      }
    }
  }


 // setting the currently conflicting services
  private storeConflictingServices() {
    _.each(this.servicesList, (service, index) => {
      const conflictingToThis = [];
      if (service.conflictingServices) {
        _.each(this.currentSelectedServices, (selectedSvc) => {
          _.each(service.conflictingServices, (item) => {
            if (selectedSvc.soc === item) {
              conflictingToThis.push(item);
            }
          });
        });

      }
      service.currentlyConflictingWith = conflictingToThis;
    });
  }

  // getting current services total
  changeCurrentservicesTotal() {
    this.currentServicesTotal = COMMON_CONSTANTS.DIGITS.ZERO;
    _.each(this.servicesList, (service) => {
      if (service.isSelected && !isNullOrUndefined(service.price)) {
        this.currentServicesTotal += Number(service.price);
      }
    });

  }

  routeBack() {
    if (this.screenName && this.screenName.toLowerCase() === COMMON_CONSTANTS.LINE_DETAILS) {
      this.router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_LINE_DETAILS]);
      window.sessionStorage.removeItem('screenName');
    } else if (this.isEndUser) {
      this._utilsSvc.navigateToDashboard();
    }
    else {
      this.router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_MANAGE_LINES]);
    }
  }

  ngOnDestroy() {
    if (this.serviceSelectionChangedSubs) {
      this.serviceSelectionChangedSubs.unsubscribe();
      this._changeSvc.serviceSelectionChanged.next(false);
    }
    if (this.triggerPromoApiSubs) {
      this.triggerPromoApiSubs.unsubscribe();
      this._changeSvc.triggerPromoApi.next(false);
    }
  }

}
